import { DEFAULT_EFFECTS_ORDER } from './constants';
import { Effects, type RemixerState, type EffectValues } from './types';

const initialState: RemixerState = {
  initialSongRequestId: null,
  songs: {},
  project: {
    id: null,
    title: null,
    musicFilePath: null,
    isInLibrary: false,
    duration: null,
    effects: Object.keys(Effects).reduce(
      (acc, key) => ({ ...acc, [key]: 0 }),
      {} as EffectValues
    ),
    history: [],
    historyPointer: -1,
    createdAt: null,
    lastSavedAt: null,
    effectsOrder: DEFAULT_EFFECTS_ORDER,
  },
  prevProjectState: null,
};

export default initialState;
